<template>
  <apexchart
    type="donut"
    height="230"
    :options="chartOptions"
    :series="series"
  ></apexchart>
</template>

<script>
export default {
  data: () => ({
    series: [100, 25],
    chartOptions: {
      chart: {
        width: 380,
        type: "donut",
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                showAlways: true,
                show: true,
              },
            },
          },
        },
      },     
      fill: {
        type: "gradient",
      },
      legend: {
        formatter: function (val, opts) {
          return val + " - " + opts.w.globals.series[opts.seriesIndex];
        },
      },
      labels: ["Submitted", "Balance"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  }),
};
</script>

<style>
</style>